import React from "react";

import {
  AnalyticsV2WidgetLoadingState,
  AnalyticsV2WidgetSize,
  Period,
  ChartMultiLine,
  IPeriodWiseMultiLineDateUsageDataPoints,
  MultiWidgetContainer,
  EmptyState
} from '@tdp/modules/apps';

export const MultiLineWidget: React.FC<{
  status: AnalyticsV2WidgetLoadingState
  size: AnalyticsV2WidgetSize
  data?: IPeriodWiseMultiLineDateUsageDataPoints
  header: string,
  isNew?: boolean
}> = React.memo(({ data, size, status, header, isNew }) => {

  const daily = data?.[Period.Daily]
    ? <ChartMultiLine data={data[Period.Daily]} period={Period.Daily} />
    : <EmptyState />;

  const weekly = data?.[Period.Weekly]
    ? <ChartMultiLine data={data[Period.Weekly]} period={Period.Weekly} />
    : <EmptyState />;

  const monthly = data?.[Period.Monthly]
    ? <ChartMultiLine data={data[Period.Monthly]} period={Period.Monthly} />
    : <EmptyState />;

  return <MultiWidgetContainer
    size={size}
    header={header}
    loadingState={status}
    daily={daily}
    weekly={weekly}
    monthly={monthly}
    isNew={isNew}
  />
});
